(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/View', 'templates'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = {
      eregFooter: require('./eregFooter.hbs')
    };
    module.exports = factory(require('backbone-torso/modules/View'), templates);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoView, templates) {
  'use strict';

  /**
   * Static View to display the ereg footer
   *
   * @class eregFooterView
   * @constructor
   */
  return new (TorsoView.extend({
    tagName: 'footer',
    id: 'page-footer',
    className: 'portal-page-footer tablet-page-footer',
    moduleNamespace: 'eregFooter',
    template: templates.eregFooter
  }))();
}));
